import React from 'react';

const NavItems = ({ navItems, activeItem, handleItemClick, isMobile = false }) => {
  return (
    <>
      {navItems.map((item) => (
        <button
          key={item.name}
          onClick={() => handleItemClick(item.name, item.link)}
          className={`
            ${isMobile
              ? 'w-full text-left px-4 py-3 rounded-md text-sm font-medium'
              : 'px-3 py-2 rounded-full text-[13px] font-normal transition-colors duration-200'
            }
            ${activeItem === item.name
              ? (isMobile ? 'bg-gray-100 text-brand-teal font-medium' : 'text-brand-teal font-medium')
              : (isMobile ? 'text-gray-600 hover:text-brand-teal hover:bg-gray-50' : 'text-gray-500 hover:text-brand-teal')
            }
          `}
        >
          {item.name}
        </button>
      ))}
    </>
  );
};

export default NavItems;